import { render, staticRenderFns } from "./AccountWrapper.vue?vue&type=template&id=b84a09fc&scoped=true&"
import script from "./AccountWrapper.vue?vue&type=script&lang=js&"
export * from "./AccountWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AccountWrapper.vue?vue&type=style&index=0&id=b84a09fc&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84a09fc",
  null
  
)

export default component.exports